import React, {useState} from 'react';
import axios from "axios";
import BookItem from "./BookItem";
import './style.css';
import Footer from "./Footer";


const Book = () => {
    const [search, setSearch] = useState("")
    const [bookData, setData] = useState([]);
    const searchBook = (evt) => {
        if(evt.key === 'Enter'){
            axios.get('https://www.googleapis.com/books/v1/volumes?q='+search+'&key=AIzaSyCy-1CQwukwx70IZDqsSwwh-PT9A5hRpWI'+'&maxResults=40')
                .then(res =>setData(res.data.items))
                .catch(err => console.log(err))
        }
    }
    return (
        <div className='books'>
        <div className='book'>
         <div className="book_form">
            <input
                type="text"
                placeholder='search your books'
                value={search}
                onChange={e=>setSearch(e.target.value)}
                onKeyPress={searchBook}
            />
           <i className="material-icons search">search</i>
         </div>
            <h2>FIND YOUR BOOK </h2>
        </div>
            <div className='main'>
                <BookItem book={bookData} />
            </div>

            <Footer />
        </div>
    );
};

export default Book;